import React from 'react';
import { emptyCategory } from 'images/careers';
import { Box, Grid, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Image from 'blog/components/Image';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginTop: theme.spacing(7.5),
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(11),
      },
    },
    img: {
      maxWidth: 354,
      [theme.breakpoints.up('sm')]: {
        maxWidth: 'auto',
      },
    },
    text: {
      fontWeight: 600,
      maxWidth: 546,
      color: theme.palette.common.black,
      margin: '0 auto',
    },
  });
});

const EmptyCategory = () => {
  const classes = useStyles();
  return (
    <>
      <Grid container direction="row" justify="center" className={classes.root}>
        <Grid item>
          <Image src={emptyCategory} alt={'empty-category'} layout="fill" className={classes.img} />
        </Grid>
      </Grid>
      <Box mt={5} mb={3}>
        <Typography variant="h3" align="center" className={classes.text}>
          We don’t have any open positions in this field.
        </Typography>
      </Box>
      <Typography variant="h5" align="center" className={classes.text}>
        Please come back later. We’ll add more vacancies shortly.{' '}
      </Typography>
    </>
  );
};

export default EmptyCategory;
